const CALL_OUT_24 = "CALL_OUT_24";
const CALL_OUT_48 = "CALL_OUT_48";

export default {
    CALL_OUT_24,
    CALL_OUT_48
};